import Vue from 'vue';
import Vuex from 'vuex';
import Web3 from 'web3';
import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { user,web3_api } from '@/api/index'
import { NetConfig } from '@/config/constants/netWorkConfig.js';
//模块化store
// import Sys from '../components/modal/store';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    defaultaddress: "",
    HomeNOticeInfo: {
      id: 0,
      time: 0,
      isWithin4Days: false
    },
    NFTNoticeInfo: {
      id: 0,
      time: 0,
      isWithin4Days: false
    },
    lang: 'en-US',
    provider: {},
    account: '',
    net: 0,
    gasPrice: 5000000000,
    slippage: 0.1,
    deadline: 20,
    multipath: true,
    transactions: {},
    block: 0,
    expert: false,
    ColorCheckData: 'white',
    updateIndex: 0,
    netWorkConfig: {

    },
  },
  mutations: {
    SETCOLORCHECKDATA: (state, ColorCheckData) => {
      state.ColorCheckData = ColorCheckData;
    },
    SETNETWORKCINFIG: (state, netWorkConfig) => {
      state.netWorkConfig = netWorkConfig;
    },
    SETUPDATEINDEX: (state, updateIndex) => {
      state.updateIndex = updateIndex;
    },
    SETDEFAULTADDRESS: (state, defaultaddress) => {
      state.defaultaddress = defaultaddress;
    },
    SETPROVIDER: (state, provider) => {
      state.provider = provider;
    },
    SETNFTNOTICEINFO: (state, NFTNoticeInfo) => {
      state.NFTNoticeInfo = NFTNoticeInfo;

    },
    SETGONGAOID: (state, HomeNOticeInfo) => {
      state.HomeNOticeInfo = HomeNOticeInfo;

    },
    SETLANG: (state, lang) => {
      state.lang = lang;
    },
    SETBLOCK: (state, block) => {
      state.block = block;
    },
    DELETETRANSACTIONS: state => {
      state.transactions = {};
    },
    SETEXPORT: (state, provider) => {
      state.expert = provider
    },
    SETTRANSACTIONS: (state, transactionsDetail) => {
      let tempObj = JSON.parse(JSON.stringify(state.transactions));
      tempObj[transactionsDetail.hash] = transactionsDetail;
      state.transactions = tempObj;
    },
    SETTRANSACTIONSRECEIPT: (state, transactionsDetail) => {
      let tempObj = JSON.parse(JSON.stringify(state.transactions));
      tempObj[transactionsDetail.hash].receipt = transactionsDetail.receipt;
      state.transactions = tempObj;
    },
    SETACCOUNTS: (state, account) => {

      state.account = account;

      if (account != '') {
        let data = {
          address: state.account,
        }
        user.postregister(data).then(res => {
          if (res.code == 200) {
          }
        });
      }


    },
    SETNET: (state, net) => {
      state.net = net;
    },
    SET_GASPRICE(state, gasPrice) {
      state.gasPrice = gasPrice;
    },
    SET_SLIPPAGE(state, slippage) {
      state.slippage = slippage;
    },
    SET_DEADLINE(state, deadline) {
      state.deadline = deadline;
    },
    SET_MULTIPATH(state, multipath) {
      state.multipath = multipath;
    },
    SET_EXPORT(state, ex) {
      state.expert = ex
    }
  },
  actions: {
    async changeWallet({ dispatch, commit }) {

      if (Object.keys(this.state.netWorkConfig).length === 0) {
        commit('SETNETWORKCINFIG', NetConfig[0]);
      } else {
        // 根据当前配置的chainId在NetConfig中查找匹配项
        const matchingConfig = NetConfig.find(config =>
          config.chainId === this.state.netWorkConfig.chainId
        );

        // 如果找到匹配项则使用，否则使用默认配置
        commit('SETNETWORKCINFIG', matchingConfig || NetConfig[0]);
      }
      console.log('this.state.netWorkConfig',this.state.netWorkConfig.chainId);
      
      web3_api.switchEthereumChain(this.state.netWorkConfig.chainId).then(res => {
      })

    },
    async getAccount({ commit }) {
      const account = await web3_api.requestWeb3ApplianceAccount()
      commit('SETACCOUNTS', account);
      },
    
   changedAccount({ commit,dispatch }) {
      window.ethereum.on('accountsChanged', (accounts) => {
       dispatch('getAccount')
      });

    }
  },
  plugins: [
    createPersistedState({
      paths: ['gasPrice', 'slippage', 'deadline', 'multipath', 'transactions', 'block', "expert", "defaultaddress", 'account', 'lang', 'HomeNOticeInfo', 'ColorCheckData', 'NFTNoticeInfo', "netWorkConfig"],
    }),
  ],
});
